import packingRequest from '../request/packing'

const apiRequest = packingRequest()

export const getListShippingCarrier = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-carriers/search`,
        method: 'POST',
        data: payload
    })

    return data
}

export const getListShippingBox = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-box/search`,
        method: 'POST',
        data: payload
    })

    return data
}

export const deleteShippingBox = async (id) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-box/${id}/delete`,
        method: 'DELETE',
    })

    return data
}